import styled from 'styled-components';
import DetailConfirmedSvg from '../../assets/mytrips/detail-confirmed.svg';

const DetailConfirmedIcon = styled(DetailConfirmedSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '46.5rem'};
  height: ${props => props.height || '14.1rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default DetailConfirmedIcon;
